import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-logos-with-link-for-darkmode',
  templateUrl: './logos-with-link-for-darkmode.component.html',
  styleUrls: ['./logos-with-link-for-darkmode.component.css']
})
export class LogosWithLinkForDarkmodeComponent {
  constructor() { }
}
